import { render, staticRenderFns } from "./kompetensi.vue?vue&type=template&id=833b6856&"
import script from "./kompetensi.vue?vue&type=script&lang=js&"
export * from "./kompetensi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports